/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  PrescribingHabits,
  PrescribingHabitsFromJSON,
  PrescribingHabitsFromJSONTyped,
  PrescribingHabitsToJSON,
} from "./";

/**
 *
 * @export
 * @interface PrescribingHabitsIEnumerableControllerResponse
 */
export interface PrescribingHabitsIEnumerableControllerResponse {
  /**
   *
   * @type {Array<PrescribingHabits>}
   * @memberof PrescribingHabitsIEnumerableControllerResponse
   */
  data?: Array<PrescribingHabits> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof PrescribingHabitsIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function PrescribingHabitsIEnumerableControllerResponseFromJSON(
  json: any,
): PrescribingHabitsIEnumerableControllerResponse {
  return PrescribingHabitsIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function PrescribingHabitsIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PrescribingHabitsIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(PrescribingHabitsFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function PrescribingHabitsIEnumerableControllerResponseToJSON(
  value?: PrescribingHabitsIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(PrescribingHabitsToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
